import React from "react";
import { Box, Typography, Avatar, Grid, IconButton } from "@mui/material";
import { deepOrange } from "@mui/material/colors";
import Div from "@jumbo/shared/Div";

const InstructorDetails = ({ instructors, getSocialIcon }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          mb: 3,
          color: "primary.main",
          textAlign: "center",
          textTransform: "uppercase",
          letterSpacing: 1.5,
          borderBottom: (theme) => `2px solid ${theme.palette.primary.main}`,
          pb: 1,
          mx: "auto",
          width: "fit-content",
        }}
      >
        Meet Our Instructors
      </Typography>
      {instructors && instructors.length > 0 ? (
        <Grid
          container
          spacing={3}
          sx={{
            display: "flex",
            "& .MuiGrid-root": { flexBasis: "100%", maxWidth: "100%" },
          }}
        >
          {instructors.map((instructor, index) => (
            <Grid item xs={12} sm={6} md={6} key={index}>
              <Div sx={{ flexGrow: 1 }}>
                <Grid
                  container
                  spacing={3}
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid item xs={12} sm={3} md={3}>
                    <Avatar
                      src={instructor.profilePic}
                      alt={instructor.name}
                      sx={{
                        width: { xs: 60, sm: 80 },
                        height: { xs: 60, sm: 80 },
                        bgcolor: deepOrange[500],
                        boxShadow: 2,
                        mx: "auto",
                      }}
                    >
                      {instructor.name.charAt(0).toUpperCase()}
                    </Avatar>
                  </Grid>
                  <Grid item xs={12} sm={9} md={9}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: "text.primary",
                        textAlign: "center",
                      }}
                    >
                      {instructor.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.secondary",
                        mt: 0.5,
                        mb: 1.5,
                        lineHeight: 1.6,
                        textAlign: "center",
                      }}
                    >
                      {instructor.instructorDetails}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        flexWrap: "wrap",
                        justifyContent: "center",
                      }}
                    >
                      {instructor.socialLinks.map((link, idx) => (
                        <IconButton
                          key={idx}
                          component="a"
                          href={link.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {getSocialIcon(link.platform)}
                        </IconButton>
                      ))}
                    </Box>
                  </Grid>
                </Grid>
              </Div>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ textAlign: "center" }}
        >
          No instructors available.
        </Typography>
      )}
    </Box>
  );
};

export default InstructorDetails;
